module.exports = "images/doc-country-menu.61d4b648ca5a7e4533336d5b77efeaa4.png";